import React, { useState } from 'react';
import { DownloadIcon } from 'lucide-react';
import { Modal } from './Modal';
import { Button } from './Button';
interface ExcelExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExport: (dateFrom: string | null, dateTo: string | null) => void | Promise<void>;
  title: string;
  isExporting?: boolean;
}
export function ExcelExportModal({
  isOpen,
  onClose,
  onExport,
  title,
  isExporting = false
}: ExcelExportModalProps) {
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [useDateFilter, setUseDateFilter] = useState(false);
  const handleExport = async () => {
    const from = useDateFilter && dateFrom ? dateFrom : null;
    const to = useDateFilter && dateTo ? dateTo : null;
    await onExport(from, to);
  };
  return <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm" icon={<DownloadIcon className="w-5 h-5" data-id="element-5406" />} accentColor="sky" data-id="element-5405">
      
      <div className="space-y-4" data-id="element-5407">
        <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-5408">
          Selecciona el rango de fechas para exportar (opcional).
        </p>

        <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300" data-id="element-5409">
          <input type="checkbox" checked={useDateFilter} onChange={e => setUseDateFilter(e.target.checked)} className="rounded border-gray-300 dark:border-gray-600" data-id="element-5410" />
          
          Filtrar por fecha
        </label>

        {useDateFilter && <div className="grid grid-cols-2 gap-3" data-id="element-5411">
            <div data-id="element-5412">
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-5413">
                Desde
              </label>
              <input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-5414" />
            
            </div>
            <div data-id="element-5415">
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-5416">
                Hasta
              </label>
              <input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-5417" />
            
            </div>
          </div>}

        <div className="flex justify-end gap-2 pt-4 border-t border-gray-100 dark:border-gray-800" data-id="element-5418">
          <Button variant="outline" onClick={onClose} disabled={isExporting} data-id="element-5419">
            Cancelar
          </Button>
          <Button onClick={handleExport} disabled={isExporting} leftIcon={<DownloadIcon className="w-4 h-4" data-id="element-5421" />} data-id="element-5420">
            
            {isExporting ? 'Exportando...' : 'Exportar Excel'}
          </Button>
        </div>
      </div>
    </Modal>;
}